<template>
	<div class="cms-post-content-block">
		<!--
			PostContentBlock — Article Content Injection Slot
			───────────────────────────────────────────────────
			In the public SPA, the smart router replaces this block with the
			actual article content blocks before the payload is sent to the
			browser. This component therefore acts as a visual placeholder
			in the admin editor only.

			At render time on the public site the block's `injectedBlocks`
			prop will be empty (because the server has already merged the
			blocks), so this component simply renders nothing in production.
		-->
		<div v-if="!injectedBlocks || injectedBlocks.length === 0" class="cms-post-content-block__placeholder">
			<slot></slot>
		</div>
	</div>
</template>

<script>
/**
 * postContentBlock.vue — Public variant
 * ──────────────────────────────────────
 * This block is a marker / injection slot used in template pages.
 * When the server-side TemplateResolverService processes a template it
 * replaces this block with the article's own body blocks, so the public SPA
 * never actually renders this component.
 *
 * It is registered in the BLOCK_MAP so that the renderer can safely ignore it
 * if, for some reason, a block of this type survives to render time.
 */
export default {
	name: 'PostContentBlock',

	props: {
		injectedBlocks: {
			type: Array,
			default: function () { return []; }
		}
	}
};
</script>

<style scoped>
.cms-post-content-block__placeholder {
	display: none;
}
</style>
